import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { CONSTANT } from "../../utils/Constants";

export const getXmlNodeById = async (id: number) => {
  try {
    const response = await privateFetch.get(URL.REQUEST_XML_NODE_BY_ID(id));
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      console.error("Error:", error.response.data.message);
      throw new Error(error.response.data.message);
    } else {
      console.error("Error:", error.message);
      throw new Error(error.message);
    }
  }
};

export const getXmlNodeByRootName = async (rootName: string) => {
  try {
    const response = await privateFetch.get(URL.REQUEST_XML_NODE_BY_ROOT_NAME(rootName));
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      console.error("Error:", error.response.data.message);
      throw new Error(error.response.data.message);
    } else {
      console.error("Error:", error.message);
      throw new Error(error.message);
    }
  }
};

export const updateXmlNode = async (data: any, user: string) => {
  const requestBody = {
    user: user,
    ...data
  };
  
  try {
    const response = await privateFetch.put(
      URL.REQUEST_XML_NODE, 
      JSON.stringify(requestBody), 
      {
        headers: {
          ...CONSTANT.HEADER_TYPE,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      console.error("Error:", error.response.data.message);
      throw new Error(error.response.data.message);
    } else {
      console.error("Error:", error.message);
      throw new Error(error.message);
    }
  }
};